import React from 'react';
import cx from 'classnames';

import withStyles from '@mui/styles/withStyles';
import Link from '@mui/material/Link';

import taskAssocGroupStyles from '../assets/jss/crm/components/taskAssocGroupStyles';

import TaskSummary from './TaskSummary';
import NewTaskModal from './NewTaskModal';

class TaskAssocGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      taskExposureLevel: 'showOpenTasks',
      showNewTaskModal: false,
      subjectIdsNamesAndCategories: [],
      taskSubjectCategory: 'multiple', // options: inquiry, client, refCompany, refContact, multiple
    };
  }

  toggleTasksVisibility() {
    const newLevel = this.state.taskExposureLevel === 'showNoTasks' ? 'showOpenTasks' : 'showNoTasks';
    this.setState({ taskExposureLevel: newLevel });
  }

  showAllTasks() {
    this.setState({ taskExposureLevel: 'showAllTasks' });
  }

  showUIToAddNewTask(event) {
    event.stopPropagation();
    this.computeSubjectIdsNamesAndCategories();
    this.setState({ showNewTaskModal: true });
  }

  computeSubjectIdsNamesAndCategories() {
    const possibleSubjects = this.props.taskSubjectProvider.getPossibleTaskSubjects();
    const taskSubjectCategory = this.props.taskSubjectProvider.getTaskSubjectCategory();

    const subjectIdsNamesAndCategories = possibleSubjects.map((s) => {
      return { id: s.personId, name: s.preferredFullName, status: s.status };
    });

    this.setState({ subjectIdsNamesAndCategories, taskSubjectCategory });
  }

  taskIsOpen(task) {
    return task.currentState !== 'Completed' && task.currentState !== 'Canceled';
  }

  taskIsCompleted(task) {
    return task.currentState === 'Completed';
  }

  createTaskSummaries(allRelatedTasks) {
    const tasksToShow =
      this.state.taskExposureLevel === 'showAllTasks'
        ? allRelatedTasks.filter((task) => this.taskIsOpen(task) || this.taskIsCompleted(task))
        : allRelatedTasks.filter((task) => this.taskIsOpen(task));
    // We used to have: key={task.id}, but
    // apparently because we may be repainting the same page over again,
    // we need a new 'key' value or we'll not repaint the TaskSummary at all.
    const extra = Math.floor(Math.random() * 100000);
    const retVal = (
      <div>
        {tasksToShow.map((task) => (
          <TaskSummary key={task.id + extra} task={task} />
        ))}
      </div>
    );
    return retVal;
  }

  maybeCreateShowMoreRow(allRelatedTasks) {
    const { classes } = this.props;
    const completedTasks = allRelatedTasks.filter((task) => this.taskIsCompleted(task));
    const nCompleted = completedTasks.length;
    if (nCompleted === 0) return null;
    return (
      <div className={cx(classes.entityAssocGroup_showMoreRow, classes.ac_h6)} onClick={() => this.showAllTasks()}>
        <Link underline="hover">
          View {' ' + nCompleted + ' '} completed {nCompleted === 1 ? 'task ' : 'tasks '}
          <i className={'zmdi zmdi-chevron-down'} />
        </Link>
      </div>
    );
  }

  closeAndPossiblyRefresh(refreshFunc) {
    if (refreshFunc) {
      this.setState({ showNewTaskModal: false }, refreshFunc());
    } else {
      this.setState({ showNewTaskModal: false });
    }
  }

  render() {
    const { classes, allRelevantTasks, visibleFirmId, refreshFunc } = this.props;
    const { taskExposureLevel } = this.state;
    return (
      <div>
        <NewTaskModal
          show={this.state.showNewTaskModal}
          initialSubjectId={this.props.initialSubjectId}
          initialSubjectStatus={this.props.initialSubjectStatus}
          subjectIdsNamesAndCategories={this.state.subjectIdsNamesAndCategories}
          taskSubjectCategory={this.state.taskSubjectCategory}
          visibleFirmId={visibleFirmId}
          closeModalFunc={() =>
            this.setState({ showNewTaskModal: false }, () => this.closeAndPossiblyRefresh(refreshFunc))
          }
        />
        <div className={classes.entityAssocGroup}>
          <div className={classes.entityAssocGroup_header} onClick={() => this.toggleTasksVisibility()}>
            <div className={classes.quickAddToggle} onClick={(event) => this.showUIToAddNewTask(event)}>
              <div className={classes.addOneButton + ' ' + classes.button_icon}>
                <i className="zmdi zmdi-plus" />
              </div>
            </div>
            <div className={classes.entityAssocGroup_title + ' ' + classes.ac_h4}>
              Tasks ({allRelevantTasks.length})&nbsp;
              {allRelevantTasks.length ? (
                <i
                  className={cx(
                    classes.entityAssocGroup_expand,
                    'zmdi',
                    { 'zmdi-chevron-right': taskExposureLevel === 'showNoTasks' },
                    { 'zmdi-chevron-down': taskExposureLevel !== 'showNoTasks' }
                  )}
                />
              ) : null}
            </div>
          </div>
          {taskExposureLevel !== 'showNoTasks' && this.createTaskSummaries(allRelevantTasks)}
          {taskExposureLevel === 'showOpenTasks' && this.maybeCreateShowMoreRow(allRelevantTasks)}
        </div>
      </div>
    );
  }
}

export default withStyles(taskAssocGroupStyles)(TaskAssocGroup);
